<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12">
                <FormInput 
                    label="Descripción" 
                    type="text" 
                    name="descripcion" 
                    id="descripcion" 
                    rules="required" 
                    v-model="parcelaData.description" 
                />
            </b-col>
            <b-col cols="12">
                <FormInput 
                    label="Precio" 
                    type="number" 
                    step="0.01" 
                    name="precio" 
                    id="precio" 
                    rules="required" 
                    v-model="parcelaData.precio" 
                />
            </b-col>
            <b-col cols="12">
                <div class="form-group">
                    <label for="fecha inicio">Fecha inicio</label>
                    <ValidationProvider name="fecha inicio" rules="required" v-slot="{ errors }" mode="eager">
                        <datetime
                            :min-datetime="new Date().toISOString()"
                            v-model="parcelaData.start_date"
                            input-class="form-control"
                            type="datetime"
                            input-id="fecha inicio"
                            value-zone="Europe/Madrid"
                            @input="clearFecha"
                        />
                        <span 
                            v-if="errors[0]" 
                            class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" 
                        >
                            {{ errors[0] }}
                        </span>
                    </ValidationProvider>
                </div>
            </b-col>
            <b-col cols="12">
                <div class="form-group">
                    <label for="fecha fin">Fecha fin</label>
                    <ValidationProvider name="fecha fin" rules="required" v-slot="{ errors }" mode="eager">
                        <datetime
                            :disabled="parcelaData.start_date == ''"
                            :min-datetime="parcelaData.end_date"
                            v-model="parcelaData.end_date"
                            input-class="form-control"
                            type="datetime"
                            input-id="fecha fin"
                            value-zone="Europe/Madrid"
                        />
                        <span 
                            v-if="errors[0]" 
                            class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" 
                        >
                            {{ errors[0] }}
                        </span>
                    </ValidationProvider>
                </div>
            </b-col>
            <b-col cols="12" class="text-right mt-3">
                <Button type="submit" :disabled="loading">Continuar</Button>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>
<script>
    import FormInput from '@/components/common/FormInput'; 
    import { ValidationObserver } from 'vee-validate';
    export default {
        props: {
            parcela: {
                type: Object,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                parcelaData: {
                    ...this.parcela
                }   
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado', this.parcelaData);
                }
            },
            clearFecha() {
                if(new Date(this.parcelaData.start_date) > new Date(this.parcelaData.end_date)){
                    this.parcelaData.end_date = '';
                }
            }
        },
        component:{
            FormInput,
            ValidationObserver
        }
    }
</script>